const months = ['joulukuu', 'tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'];


function zeroPad(num) {
  if (num < 10) {
    return "0" + num;
  }
  return num;
}

const utils = {
  // dates
  date2dmy: (date) => {
    return [
      zeroPad(date.getDate()),
      zeroPad(date.getMonth() + 1),
      date.getFullYear()
    ].join('.');
  },

  date2ymd: (date) => {
    return [
      date.getFullYear(),
      zeroPad(date.getMonth() + 1),
      zeroPad(date.getDate())
    ].join('-');
  },

  unix2dmy: (ts) => {
    return utils.date2dmy(new Date(ts * 1e3));
  },

  unix2ymd: (ts) => {
    return utils.date2ymd(new Date(ts * 1e3));
  },

  ymd2dmy: (dateString, noTime) => {
    if (!dateString) return '';

    // if has time
    if (dateString.length > 10) {
      const timeSplit = dateString.split(' ');
      return utils.ymd2dmy(timeSplit[0]) + (!noTime ? ' ' + timeSplit[1] : '');
    }

    return dateString.split('-')
      .reverse()
      .join('.');
  },

  ymdIsExpired: (dateString) => {
    if (!dateString) return false;

    let now = new Date();
    now.setHours(0, 0, 0, 0);

    return new Date(dateString) <= now;
  },

  ymdIsExpiring: (dateString) => {
    if (!dateString) return false;

    let now = new Date();
    now.setHours(0, 0, 0, 0);

    // 3 days
    now.setDate(now.getDate() + 3);

    return new Date(dateString) <= now;
  },
};

export default utils;

// classnames
export function cn(...args) {
  return args.filter(i => i).join(' ');
}

export function shallowDiffers(a, b) {
  for (let i in a) if (!(i in b)) return true
  for (let i in b) if (a[i] !== b[i]) return true
  return false
}

export function getExtension(filename) {
  if (typeof filename !== 'string') return '';

  const lastDot = filename.lastIndexOf('.');

  if (lastDot === -1) return '';

  return filename.slice(lastDot + 1).toLowerCase();
}

export function currency(value) {
  if (typeof value !== 'number') return value;
  return value.toFixed(2) + ' €';
}

export function placeholderRows(max = 2, min = 1) {
  return new Array(Math.floor(Math.random() * (max + 1 - min) + min)).fill();
}

export function monthNoToName(month) {
  return months[month]
}

export function number(input) {
  if (!input) {
    return input;
  }
  return Math.round(input).toLocaleString().replace(/,/g, ' ').replace('.', ',');
}

export function round2d(n) {
  var d = Math.abs(n - Math.trunc(n));
  if (d > 0) {
    return Math.round(n * 100) * 0.01;
  }

  return n;
}
export function getCents(n) {
  if (n === undefined || n === null) { return ',--' };
  var noDecimals = ',00'; //Jos ei desimaaleja
  var s = round2d(n);
  s = s.toString(); //muutetaan merkkijonoksi
  var index = s.indexOf('.'); //Haetaan pisteen indeksiä
  if (s.includes('.')) { //sisältääkö pisteen
    s = s.slice(index + 1, index + 3); //otetaan pisteen jälkeiset 2 merkkiä 
    if (s.length === 1) { //jos niitä on 1 
      return ',' + s + '0' //lisätään luvun eteen pilkku ja perään 0
    } else {
      return ',' + s;
    } //lisätään pilkku kahden desimaalin eteen
  } else return noDecimals; //kokonaislukuun lisätään ',00'
}

export function getEuros(n) {
  if (n === undefined || n === null) return "----";
  n = parseInt(n);
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function parseError(error) {
  switch (error.status) {
    case 400:
      return "Tietojen haku epäonnistui";
    default:
      return "Tapahtui virhe"
  }
}
